import { render, staticRenderFns } from "./NewLogin.vue?vue&type=template&id=5afd3263&scoped=true&"
import script from "./NewLogin.vue?vue&type=script&lang=ts&"
export * from "./NewLogin.vue?vue&type=script&lang=ts&"
import style0 from "./NewLogin.vue?vue&type=style&index=0&id=5afd3263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd3263",
  null
  
)

export default component.exports